import React from "react";
import PropTypes from "prop-types";

import { StoryCard } from "../basic/story-card.js";
import { StoryList } from "../basic/story-list.js";
import { AdService } from "../ad-service";
import { CollectionName } from "../atoms/collection-name/index.js";

import { wrapCollectionLayout } from "@quintype/components";
import { isEager, getRowMetadata } from "../../utils.js";

function TwoColOneAdBase({ collection, config, stories, associatedMetadata, index }) {
  const storyCardConfig = {
    section: true,
    subheadline: true,
    image: true,
    imageWidth: [400]
  };
  const storyListConfig = {
    section: true
  };
  const pbAheadConfig = getRowMetadata(config, associatedMetadata);
  const { show_collection_title: collectionName = true } = pbAheadConfig;
  return (
    <div className="component-wrapper" data-test-id="two-col-one-ad-component">
      {collectionName ? <CollectionName name={collection.name} config={config} section={collection} /> : null}
      <div className="two-col-one-ad">
        <div>
          <StoryCard eager={isEager(index, true)} story={stories[0]} config={storyCardConfig} />
        </div>
        <div>
          <StoryList stories={stories.slice(1, 4)} config={storyListConfig} />
        </div>
        <div>
          <StoryList stories={[stories[4]]} config={storyListConfig} />
          <div className="app-ad app-ad--mrec">
            <AdService
              adtype="Mrec"
              layoutName="TwoColOneAd"
              collectionSlug={collection.slug}
              slotId={`TwoColOneAd-${index}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

TwoColOneAdBase.propTypes = {
  collection: PropTypes.object,
  config: PropTypes.object,
  associatedMetadata: PropTypes.object,
  stories: PropTypes.array,
  index: PropTypes.number
};

export const TwoColOneAd = wrapCollectionLayout(TwoColOneAdBase);
